import { ErrorName } from './Error.utils';
import { ErrorWithUi } from './ErrorWithUi';

export class MissingPermissionError extends ErrorWithUi {
  readonly name = ErrorName.MissingPermission;
}
